var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HeadedLinkedList',{attrs:{"headerElement":_vm.headerElement,"headerText":"Blog Posts","items":_vm.posts}})}
var staticRenderFns = []

export { render, staticRenderFns }